// CardTitle
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.h3`
  padding: 2vw 1vw;
  color: rgba(255, 255, 255, .8);
  font-weight: bold;
  font-size: 1.7rem;
  letter-spacing: 4px;
  background-color: ${ props => (props.primary ? '#436CDE' : '#5B39B1') };
`;
function CardTitle(props) {
  return (
    <Wrapper className="common-card-title">{props.cardTitle}</Wrapper>
  );
}

CardTitle.propTypes = {
  cardTitle: PropTypes.string
};

export default CardTitle;


// WEBPACK FOOTER //
// ./src/features/common/CardTitle.js